// extracted by mini-css-extract-plugin
export var container = "post-preview-module--container--b0aab";
export var imageWrapper = "post-preview-module--image-wrapper--ba826";
export var little = "post-preview-module--little--7f20f";
export var ratio = "post-preview-module--ratio--ba40b";
export var tagsWrapper = "post-preview-module--tags-wrapper--beba8";
export var titleText = "post-preview-module--title-text--b90e4";